export const Spacer = ({ x, y }: { x?: string; y?: string }) => {
  return <div style={{ width: x ?? 0, height: y ?? 0 }} />;
};
